export default __webpack_public_path__ + "static/media/linkedin.357e5615.png";